import { httpCreate } from './http';

const http = httpCreate('/shop/api/guide');

export const guide = {
	brandList(id) {
		return http.get('/brand/list', {
			params: {
				storeUserId: id,
			},
		});
	},
	brandStoreList(id) {
		return http.get('/brandStore/list', {
			params: {
				brandId: id,
			},
		});
	},
};
